import { useContext, useState } from 'react'
import '../css/document/adddoc.css'
import { Dimcontext } from '../../context/pagecontext'
import { Button, Form, FormControl, FormGroup, FormLabel } from 'react-bootstrap'
import { MdClose } from 'react-icons/md'
import api from '../../api'
import Swal from 'sweetalert2'
import { auth } from '../../firebase'
import { ToastContainer } from 'react-toastify' 
import { useNavigate } from 'react-router-dom'

export const Adddoc = ({set_add, showToast, docg}) => {
    const navigate = useNavigate()
    const { setDim } = useContext(Dimcontext)
    const [docname, setdocname] = useState('')
    const [bt, setBt ] = useState(false)

    const handleaddclose = () => {
        setDim(false)
        set_add(false)
    }

    const add = async(e) => {
         setBt(true)
        e.preventDefault()
        // Validation with a cleaner regex
        const sanitizedName = docname.trim().toLocaleLowerCase().replace(/\s+/g, ' ')
        if (!/^[A-Za-z0-9\s,./\-()]{3,30}$/.test(sanitizedName)) {
            setBt(false)
            return showToast("Invalid Name Format (3-30 characters)");
        }

        const data = { doc_Name : sanitizedName }
        try {
            await api.post('/add_New_Document', data)
            Swal.fire({
                title: "Success!",
                text: "Document nature added successfully",
                icon: "success",
                confirmButtonColor: "#4b0082",
                timer: 2000,
            });
            handleaddclose()
            docg()
        } catch (err) {
            console.error(err); 
            if (err.response && err.response.status === 401) {
                showToast("Session expired. Attempting to refresh...");
                try {
                    // Force Firebase to get a fresh token
                    const freshToken = await auth.currentUser.getIdToken(true);
                    sessionStorage.setItem("token", freshToken);
                    // OPTIONAL: Retry the failed request with the freshToken
                    // return retryRequest(originalConfig, freshToken);
                } catch (refreshErr) {
                    // If refreshing fails, the user session is truly dead
                    showToast("Refresh failed. Logging out.");
                    navigate("/")
                    
                    // window.location.href = '/login'; 
                }
            } 
            else if(err.response && err.response.status === 400 ) {
                                        // Handle other types of errors (Network, 500, etc.)
                                        showToast("This already in Document list...");
                                    }else {
                // Handle other types of errors (Network, 500, etc.)
                showToast("Something went wrong. Please try again.");
            }
        } finally{
            setBt(false)
        }
    }

    return (
        <div className='addnod-card'>
            <ToastContainer/>
            <div className="addnod-header">
                <h4 className="m-0">Add Nature of Document</h4>
                <button onClick={handleaddclose} className='btn-close-custom' ><MdClose/></button>
            </div>
            
            <div className="addnod-body">
                <Form onSubmit={add}>
                    <FormGroup controlId='add'>
                        <FormLabel className="custom-label">Nature of Document Name</FormLabel>
                        <FormControl 
                            required
                            autoFocus
                            className="custom-input"
                            value={docname}
                            onChange={(e) => setdocname(e.target.value)}
                            placeholder='e.g. Sale Deed, Patta Chitta...'
                        />
                        <Form.Text className="text-muted">
                            Min 3 characters, max 30.
                        </Form.Text>
                    </FormGroup>
                    
                    <div className="addnod-footer">
                        <Button variant="light" onClick={handleaddclose} className="me-2 px-4">
                            Cancel
                        </Button>
                        <Button type='submit' disabled={bt} className="btn-submit px-4">
                            Save Document
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}